<div class="hero"></div>
<div class="container">
  <form [formGroup]="frmSearch" (ngSubmit)="submitSearch()">
    <div class="search grid">
      <div class="banner">
        <h1>Gruppi in partenza</h1>
        <span
          >Scopri tutti i nostri gruppi in partenza e prenota il tuo
          viaggio</span
        >
      </div>

      <div class="col-12 md:col">
        <div class="search-input">
          <p-autoComplete
            [forceSelection]="true"
            formControlName="destinations"
            placeholder="Destinazione"
            [suggestions]="suggestedCountries"
            (completeMethod)="filterCountries($event)"
            field="name"
            dataKey="ISO"
            class="frm mt-1"
            [emptyMessage]="'Nessun risultato trovato'"
            [showClear]="true"
          >
          </p-autoComplete>
        </div>
      </div>
      <div class="col-12 md:col">
        <div class="search-input">
          <p-multiSelect
            styleClass="w-full"
            [options]="types"
            optionLabel="name"
            optionValue="id"
            [showClear]="true"
            formControlName="categories"
            placeholder="Categorie"
            emptyMessage="Nessun risultato trovato."
          >
            <ng-template let-t pTemplate="type">
              <div class="flex align-items-center gap-2">
                <img [src]="t.id | travelType" />
                <span>{{ t.name }}</span>
              </div>
            </ng-template>
          </p-multiSelect>
        </div>
      </div>
      <div class="col-12 md:col">
        <p-autoComplete
          formControlName="leader"
          styleClass="w-full"
          [suggestions]="suggestedLeaders"
          (completeMethod)="filterLeaders($event)"
          placeholder="Organizzatore"
          dataKey="id"
          [forceSelection]="true"
          emptyMessage="Nessun risultato"
          emptyFilterMessage="Nessun risultato trovato"
          [optionLabel]="getLeadersNameToDisplay"
          [showClear]="true"
        >
          <ng-template let-leader pTemplate="item">
            <div class="flex align-items-center gap-2">
              <p-avatar
                [image]="leader.profile_picture | imagePipe : 'user' : 'sm'"
                shape="circle"
              ></p-avatar>
              <div>{{ leader.name }} {{ leader.last_name }}</div>
            </div>
          </ng-template>
        </p-autoComplete>
      </div>
      <div class="col-12 md:col">
        <p-button
          styleClass="w-full slide"
          label="Cerca"
          size="small"
          type="submit"
        ></p-button>
      </div>
    </div>
  </form>

  @if(loading){
  <div class="backdrop-mini-loader">
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
  </div>
  }@else {
  <div class="mt-6 mb-10">
    <div class="grid">
      @for (t of travels; track $index) {
      <div class="col-12 md:col-6 lg:col-4 xl:col-3">
        <app-travel-card-minimal [travel]="t"></app-travel-card-minimal>
      </div>
      }
    </div>

    @if(totalRecords === 0){
    <div class="flex align-items-center justify-content-center mt-7 mb-6">
      <div class="empty-set px-0">
        <img src="/assets/media/illustrations/map.png" height="200" />
        <h5>Nessun risultato</h5>
      </div>
    </div>
    } @if(totalRecords > travels.length){
    <div class="flex align-items-center justify-content-center mt-7">
      @if(loadingMore){
      <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem"></i>
      } @else {
      <p-button
        label="Mostra altro"
        styleClass="slide px-6"
        size="small"
        (click)="showMore()"
      ></p-button>
      }
    </div>
    }
  </div>
  }
</div>

<app-request></app-request>
